/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

export type RealEstateInvestmentTypeEnum = typeof RealEstateInvestmentTypeEnum[keyof typeof RealEstateInvestmentTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealEstateInvestmentTypeEnum = {
  office: 'office',
  residential_single_family: 'residential_single_family',
  residential_multi_family: 'residential_multi_family',
  hospitality: 'hospitality',
  retail: 'retail',
  mixed_use: 'mixed_use',
  industrial: 'industrial',
  logistics: 'logistics',
  gaming_leisure: 'gaming_leisure',
  alternative_re: 'alternative_re',
  land: 'land',
  real_estate_security: 'real_estate_security',
  other: 'other',
} as const;
